export default __webpack_public_path__ + "static/media/icon-input.c1eb7b77.svg";